

















import { buildMappingChartOptions, buildYAxisDate } from '@/components/patient-stats/graphs/mapping-chart-options/'
import { ONE_DAY_HEIGHT } from '@/components/patient-stats/graphs/mapping-chart-options/constants'

export default {
  props: {
    patientWithMappingReports: {
      type: Object,
      default: null,
    },
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
  },
  computed: {
    height: function() {
      return Math.min(100 + this.yAxisDate.length * ONE_DAY_HEIGHT, 10000)
    },
    yAxisDate() {
      return buildYAxisDate(this.patientWithMappingReports)
    },
    chartOptions() {
      return buildMappingChartOptions(this.patientWithMappingReports, this.yAxisDate)
    },
  },
}
